import MapModuleMixin from '@/components/maps/mixins/MapModuleMixin'
import PermissionsMixin from './PermissionsMixin';
import FeaturesMapMixin from './FeaturesMapMixin';

export default {
    mixins: [
        MapModuleMixin,
        PermissionsMixin,
        FeaturesMapMixin,
    ],
    data() {
        return {

        }
    },
    computed: {

    },
    beforeDestroy() {
        this.closeAllPanels();
    },
}